// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topic-root {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  background: #f5f5f5;
  padding: 0 3rem 2rem 3rem;
}
.topic-root .topic-head {
  padding: 1.5rem 0;
}
.topic-page {
  flex: 1;
  display: flex;
  column-gap: 2rem;
  overflow-y: auto;
}
.topic-page .topic-left {
  width: 50%;
  height: 100%;
  border-radius: 0.75rem;
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  padding: 1.5rem 2rem;
}
.topic-page .topic-left .topic-title {
  text-align: center;
  color: #000;
  font-size: 2rem;
  font-weight: 700;
  padding-bottom: 2rem;
}
.topic-page .topic-left .topic-txt {
  color: #888b9b;
  font-size: 1rem;
  font-weight: 400;
  margin-top: 0.5rem;
}
.topic-page .topic-left .topic-item {
  margin-top: 0.6rem;
  margin-bottom: 2rem;
}
.topic-page .topic-left .tit {
  color: #000;
  font-size: 1.125rem;
  font-weight: 700;
  margin-left: 0;
}
.topic-page .topic-left .tit svg {
  margin-right: 0.3rem;
}
.topic-page .topic-left .label-icon {
  margin-right: 0.3rem;
}
.topic-page .topic-left .tit-put {
  width: 21rem;
  padding: 0.5rem;
  border-radius: 0.5rem;
  background: #f2f1f7;
  margin: 1rem 0 3rem;
}
.topic-page .topic-left .TextArea {
  border-radius: 0.25rem;
  background: #f0eff5;
  margin-top: 0.5rem;
  color: #888b9b;
  font-size: 0.875rem;
  font-weight: 400;
}
.topic-page .topic-left .start-time {
  margin-top: 1rem;
  align-items: center;
  column-gap: 1rem;
  color: #000;
  font-size: 1.125rem;
  font-weight: 700;
}
.topic-page .topic-left .start-time .label-val {
  color: #7371b6;
  font-size: 1rem;
  font-weight: 400;
}
.topic-page .topic-right {
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.topic-page .topic-right .topic-rightT {
  height: 75%;
  background: #fff;
  box-shadow: 0px 0.222px 3.502px 0px rgba(0, 0, 0, 0.01), 0px 0.978px 7.252px 0px rgba(0, 0, 0, 0.02), 0px 2.4px 14.462px 0px rgba(0, 0, 0, 0.03), 0px 4.622px 28.348px 0px rgba(0, 0, 0, 0.03), 0px 7.778px 52.123px 0px rgba(0, 0, 0, 0.04), 0px 12px 89px 0px rgba(0, 0, 0, 0.05);
  border-radius: 0.75rem;
}
.topic-page .topic-right .topic-rightT .tit {
  color: #000;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 700;
  margin: 1.2rem 2.5rem;
}
.topic-page .topic-right .topic-rightT .TextArea {
  height: 100%;
  flex: 1;
  padding: 0.6rem 2rem;
  border-radius: none;
}
.topic-page .topic-right .topic-rightA {
  height: 10%;
  border-radius: 0.75rem;
  margin-top: 5rem;
  background: #fff;
  width: 100%;
  padding: 0 0.5rem;
}
.topic-page .topic-right .topic-rightA button {
  margin: 0 0.5rem;
}
.topic-page .topic-right .topic-rightA .topic-btn1 {
  border-radius: 12px;
  background: #f2f1f7;
}
.topic-page .topic-right .topic-rightA .topic-btn2 {
  border-radius: 12px;
  background: #7270b6;
}
.topic-page .topic-right .topic-rightA .topic-btn2 span {
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/OJ/questionBank/detail.less"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mRAAmR;EACnR,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,OAAO;EACP,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb","sourcesContent":[".topic-root {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  overflow: hidden;\n  background: #f5f5f5;\n  padding: 0 3rem 2rem 3rem;\n}\n.topic-root .topic-head {\n  padding: 1.5rem 0;\n}\n.topic-page {\n  flex: 1;\n  display: flex;\n  column-gap: 2rem;\n  overflow-y: auto;\n}\n.topic-page .topic-left {\n  width: 50%;\n  height: 100%;\n  border-radius: 0.75rem;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  overflow-y: scroll;\n  padding: 1.5rem 2rem;\n}\n.topic-page .topic-left .topic-title {\n  text-align: center;\n  color: #000;\n  font-size: 2rem;\n  font-weight: 700;\n  padding-bottom: 2rem;\n}\n.topic-page .topic-left .topic-txt {\n  color: #888b9b;\n  font-size: 1rem;\n  font-weight: 400;\n  margin-top: 0.5rem;\n}\n.topic-page .topic-left .topic-item {\n  margin-top: 0.6rem;\n  margin-bottom: 2rem;\n}\n.topic-page .topic-left .tit {\n  color: #000;\n  font-size: 1.125rem;\n  font-weight: 700;\n  margin-left: 0;\n}\n.topic-page .topic-left .tit svg {\n  margin-right: 0.3rem;\n}\n.topic-page .topic-left .label-icon {\n  margin-right: 0.3rem;\n}\n.topic-page .topic-left .tit-put {\n  width: 21rem;\n  padding: 0.5rem;\n  border-radius: 0.5rem;\n  background: #f2f1f7;\n  margin: 1rem 0 3rem;\n}\n.topic-page .topic-left .TextArea {\n  border-radius: 0.25rem;\n  background: #f0eff5;\n  margin-top: 0.5rem;\n  color: #888b9b;\n  font-size: 0.875rem;\n  font-weight: 400;\n}\n.topic-page .topic-left .start-time {\n  margin-top: 1rem;\n  align-items: center;\n  column-gap: 1rem;\n  color: #000;\n  font-size: 1.125rem;\n  font-weight: 700;\n}\n.topic-page .topic-left .start-time .label-val {\n  color: #7371b6;\n  font-size: 1rem;\n  font-weight: 400;\n}\n.topic-page .topic-right {\n  width: 50%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.topic-page .topic-right .topic-rightT {\n  height: 75%;\n  background: #fff;\n  box-shadow: 0px 0.222px 3.502px 0px rgba(0, 0, 0, 0.01), 0px 0.978px 7.252px 0px rgba(0, 0, 0, 0.02), 0px 2.4px 14.462px 0px rgba(0, 0, 0, 0.03), 0px 4.622px 28.348px 0px rgba(0, 0, 0, 0.03), 0px 7.778px 52.123px 0px rgba(0, 0, 0, 0.04), 0px 12px 89px 0px rgba(0, 0, 0, 0.05);\n  border-radius: 0.75rem;\n}\n.topic-page .topic-right .topic-rightT .tit {\n  color: #000;\n  font-size: 1.25rem;\n  font-style: normal;\n  font-weight: 700;\n  margin: 1.2rem 2.5rem;\n}\n.topic-page .topic-right .topic-rightT .TextArea {\n  height: 100%;\n  flex: 1;\n  padding: 0.6rem 2rem;\n  border-radius: none;\n}\n.topic-page .topic-right .topic-rightA {\n  height: 10%;\n  border-radius: 0.75rem;\n  margin-top: 5rem;\n  background: #fff;\n  width: 100%;\n  padding: 0 0.5rem;\n}\n.topic-page .topic-right .topic-rightA button {\n  margin: 0 0.5rem;\n}\n.topic-page .topic-right .topic-rightA .topic-btn1 {\n  border-radius: 12px;\n  background: #f2f1f7;\n}\n.topic-page .topic-right .topic-rightA .topic-btn2 {\n  border-radius: 12px;\n  background: #7270b6;\n}\n.topic-page .topic-right .topic-rightA .topic-btn2 span {\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
